import { chunk } from 'lodash';

export interface ExistingAccount {
  email: string;
  first_name: string;
  last_name: string;
}

// Fetches a list of existing accounts from an array of user emails
export function fetchExistingAccounts(users: string[], managed: boolean) {
  return fetch(`/api/_private/memberships/existing_users?emails=${users}&managed=${managed}`)
    .then(handleErrors)
    .then((res) => res.json())
    .catch((err) => console.error(err.responseText));
}

// Fetches a list of accounts from an array of batched user emails by batch size
export function batchExistingAccounts(users: string[], managed: boolean, size: number) {
  const promises: Promise<any>[] = [];
  const chunkedUsers = chunk(users, size);

  chunkedUsers.forEach((userChunk) => {
    promises.push(fetchExistingAccounts(userChunk, managed));
  });

  return Promise.all(promises);
}

const handleErrors = (res) => {
  if (!res.ok) {
    // eslint-disable-next-line no-alert
    alert('Something went wrong with your request. Please refresh the page');
    throw Error(res.statusText);
  }
  return res;
};
